import PressureGraph from './PressureGraph';
export default PressureGraph;



// WEBPACK FOOTER //
// ./resources/assets/js/components/PressureGraph/index.js